import { useContext } from 'react';
import CompositionAdvancedOptions from '../components/composition-advanced-options/CompositionAdvancedOptions';
import styles from './CompositionsView.module.css';
import ThemeContext from 'config/context/themeContext';
import EditableCompositionTable from '../components/editable-composition-table/EditableCompositionTable';
import CompositionStructureView from '../components/composition-structure-view/CompositionStructureView';
import SchemaMapView from '../components/schema-map-view/SchemaMapView';
import { CompositionAdvancedOptionsContextProvider, useCompositionAdvancedOptionsContext } from '../context/CompositionAdvancedOptionsContext';

const CompositionsViewInner = () => {
    const { dark } = useContext(ThemeContext);
    const { viewType } = useCompositionAdvancedOptionsContext();
    return (
        <div className={`${styles.compositions_view} ${dark ? styles.dark : ""}`}>
            <CompositionAdvancedOptions />
            <div style={{ display: viewType === 'structure' ? 'grid' : 'none' }}>
                <CompositionStructureView />
            </div>
            <div style={{ display: viewType === 'browse' ? 'grid' : 'none' }}>
                <EditableCompositionTable />
            </div>
            {/* Mapa se montira tek kad se gleda, za razliku od druga dva pogleda:
                ona sama dohvata broj redova po kompoziciji, pa bi stalno prisutna
                trošila poziv na svaki dolazak na stranicu. Stanja koje bi se
                skrivanjem izgubilo ovde ni nema — samo polje za pretragu. */}
            {viewType === 'map' && (
                <div style={{ display: 'grid' }}>
                    <SchemaMapView />
                </div>
            )}
        </div>
    )
}

const CompositionsView = () => (
    <CompositionAdvancedOptionsContextProvider>
        <CompositionsViewInner />
    </CompositionAdvancedOptionsContextProvider>
)

export default CompositionsView;